export default __webpack_public_path__ + "static/media/logo-masihiy-color.f9acb16f.png";